import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { SdeliveryNote } from './s-delivery-note';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';

export class WarehouseTransferRequest extends BaseEntity {
  
  warehouseTransferCode     : string;
  product                   : Product;
  productBatchCode          : string;
  	
	//------------------------------------------------------------------------
  requestedQuantity         : number;
  confirmedQuantity         : number;
  assignedQuantity          : number;
	//------------------------------------------------------------------------

	//------------------------------------------------------------------------
  requestedReturnedQuantity : number;
  confirmedReturnedQuantity : number;
  assignedReturnedQuantity  : number;
	//------------------------------------------------------------------------

	//------------------------------------------------------------------------
  requestedReturnedDamagedQuantity1 : number;
  confirmedReturnedDamagedQuantity1 : number;
  assignedReturnedDamagedQuantity1 : number;
	//------------------------------------------------------------------------
 
	
	//------------------------------------------------------------------------
  requestedReturnedDamagedQuantity2 : number;
	confirmedReturnedDamagedQuantity2 : number;
	assignedReturnedDamagedQuantity2  : number;
	//------------------------------------------------------------------------
  

	//------------------------------------------------------------------------
	requestedDamagedQuantity1         : number;
	confirmedDamagedQuantity1         : number;
	assignedDamagedQuantity1          : number;
	//------------------------------------------------------------------------
	
	//------------------------------------------------------------------------
	requestedDamagedQuantity2         : number;
	confirmedDamagedQuantity2         : number;
	assignedDamagedQuantity2          : number;
  //------------------------------------------------------------------------
  availableQuantity                 : number;

  sdeliveryNotes            : SdeliveryNote[];
  balanced                  : boolean;
  initialyBalanced          : boolean;


  // Transient
  movedQuantity1             : number;
  movedQuantity2             : number;
  movedQuantity3             : number;
  movedQuantity4             : number;
  
  constructor() {
    super()
  }
 
}
 


